import React from 'react';
import {
    Button,
} from '@mui/material';

function Step4() {
   

    return (
        <>
            <div className="form">
                <h3 className="hd_6">AI Retention Prompt</h3>



                    <div className="control_group mt_20 chat_form">
                        <label htmlFor="">We’ve noticed a drop in your recent sales. Would you like personalized advice on how to recover before closing?</label>
                     
                    </div>
                    <div className="btn_flex1">
                        <Button className='btn btn_grey'>Yes, help me improve my store</Button>
                    </div>
            
            </div>
        </>
    );
}

export default Step4;
